import React from 'react';
import * as Auth from '../../domains/AuthDomain';
import standardizeEmail from '../../common/standardizeEmail';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      emailValid: false,
      emailError: '',
      successMessage: '',
      success: false,
      authLoading: false,
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
  }

  renderHeader = () => {
    let sectionsClass = 'navbar-section';
    if (this.props.route.navBarColor === 'trybe-black') {
      sectionsClass = 'navbar-section-black';
    }

    return (
      <div className='navbar-section-black'>
        <div className='navbar-content'>
          <div
            className='logo-container'
            onClick={() => {
              window.location.href = 'https://trybe.fit';
            }}
          >
            <img
              className='logo-img'
              src={require('../../images/trybe-logo-white.svg')}
            />
            <div className='logo-text'>TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  onClickReset = async () => {
    this.setState({ authLoading: true });
    let { email } = this.state;
    email = standardizeEmail(email);
    const emailValid = Auth.checkEmailValid(email);

    if (emailValid) {
      const { statusCode, error, error_description } = await Auth.resetPassword(
        {
          email,
        }
      );

      if (statusCode === 200) {
        this.setState({
          success: true,
          emailError: false,
          authLoading: false,
        });
      } else {
        this.setState({
          success: false,
          emailError:
            'There was an error in resetting your password. Please double check the email you entered.',
          authLoading: false,
        });
      }
    } else {
      this.setState({
        success: false,
        emailError: 'Please double check you entered a valid email',
        authLoading: false,
      });
    }
  };

  onClickBack = () => {
    this.props.history.goBack();
  };

  canGoBack = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.allowBack
    ) {
      return true;
    } else {
      return false;
    }
  };

  renderBack = () => {
    if (this.canGoBack()) {
      return (
        <button
          onClick={() => {
            this.onClickBack();
          }}
          className='back-button'
        >
          Back
        </button>
      );
    } else {
      return <div className='spacer'></div>;
    }
  };

  render() {
    const promptText = `Enter your email address and we will send you a link to reset your password.`;
    const successText = `Check your email for a link to reset your password. If it doesn’t appear within a few minutes, please check your spam folder.`;
    return (
      <div className='reset-password-container'>
        {this.renderHeader()}
        <div className='reset-form'>
          <div className='form-header'>Forgot your password?</div>
          <div className='padding-wrapper'>
            {!this.state.success ? (
              <div className='form-description'>{promptText}</div>
            ) : (
              <div className='form-description'>{successText}</div>
            )}

            {!this.state.success ? (
              <input
                type='text'
                className='email-input'
                placeholder='E-mail'
                id='login-email'
                maxLength='254'
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                value={this.state.email}
              />
            ) : null}
            <div className='login-messages'>
              <div className='error-text'>
                {this.state.emailError ? this.state.emailError : null}
              </div>
            </div>
            {!this.state.success ? (
              <button
                type='button'
                className='finish-reset-button'
                disabled={
                  this.state.email || this.state.successMessage ? false : true
                }
                onClick={() => {
                  this.onClickReset();
                }}
              >
                {this.state.authLoading ? (
                  <div className='loader' />
                ) : (
                  'Reset Password'
                )}
              </button>
            ) : (
              this.renderBack()
            )}
          </div>
        </div>
        <div className='contact-us'>
          Need further support? Contact us at{' '}
          <a className='link' href='mailto:support@trybe.do'>
            support@trybe.do
          </a>
        </div>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/ResetPasword.js